export const stringsKey = "GroupName";
export const englishStrings = {
	groupNameLabel: "Group Name",
};
